<script>
import PrintCW from './PrintCW';
import PageIntro from '@/components/elements/PageIntro';
import printMixin from './print-mixin';

export default {
    name: 'PrintTestCW',
    components: { PrintCW, PageIntro },
    mixins: [printMixin],
    methods: {
        back() {
            this.$router.push({ name: 'TestOverviewCW' });
        },
        getQRCode() {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.$store.state.accToken}`
            }
            this.$axios
                .post(this.$config.apiacthealth + 'DccIssuances/issueTestQrCode', { token: this.token, code: this.verificationCode, crossdomain: true, responseType: 'blob' },
                    { headers })
                .then(response => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'QRCodeTestDCC.pdf');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch(error => {
                    console.log(error)
                    this.errored = true
                })
        }
    },
    data() {
        return {
            pageType1: 'local',
            token: null,
            verificationCode: -1,
            image: '',
            hostname: this.$config.host
        }
    },
    mounted() {
        if ((this.$store.state.userConsent !== true) && (this.$store.state.createDCCVerify !== true)) {
            this.$router.push({ name: 'Home' });
        }
        this.token = this.$store.state.pToken;
        this.verificationCode = this.$store.state.pVerificationCode;
    }
}
</script>

<template>
    <div class="PrintTest">
        <PrintCW
            @back="back"
            :type="'test'" :token="token" :verificationCode="verificationCode">
            <PageIntro
                :head="$t('views.printTest.' + pageType1 + '.pageHeader')"
                :intro="$t('views.printTest.' + pageType1 + '.pageIntro')"/>
        </PrintCW>
    </div>
</template>
